// React imports.
import React, { Component } from "react";

// App imports.


const StartNewAssessment = ({ state }) => (
  <div>
    <p><strong>CHOOSING AN ASSESMENT:</strong></p>
    <p>This is the screen from which you can start a new assessment.</p>
    <p>
      <strong>Before you begin</strong> an assessment, you will need to click the corresponding
      &nbsp;<strong>Before You Begin</strong> button for that assessment in the table below
      to download a PDF of the data items you will need. These
      PDFs can be given directly to your database programmers
      so that they can pull the data you will need to complete
      the assessment.
    </p>
    <p>
      <strong>One you have all of the necessary data</strong> you can click on
      the <strong>Start Assessment</strong> button to begin working through
      the assessment.
    </p>
    <p>
      <strong>Important Note:</strong> The Overall Reliability Assessment is designed to
      conduct a preliminary screening of your data and alert you to where your data look
      reliable and where you might want to dig deeper into potential issues using one
      of the assessments. Therefore, you should always complete the Overall Reliability
      Assessment first whenever you are beginning to use the tool for a program year
      that you have not analyzed before.
    </p>

    <strong>Select an Assessment:</strong>
    <br /><br />
    <table data-bind="visible:savedAssessments().length>0">
      <thead>
        <tr>
          <th>Assessment #</th>
          <th>Assessment Name</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>

        <tr>
          <td >Overall</td>
          <td >Overall Reliability Assessment</td>
          <td >
            <a href="/data_warehouse/doc/Before You Begin - MHOA.pdf" target="_blank">Before You Begin</a><br />
            <a href='#' onClick={() => state.startNewAssessementAssessmentSelected(5)}>Begin Assessment</a>
          </td>
        </tr>

        <tr>
          <td >1</td>
          <td >Defining Data Requirements</td>
          <td >
            <a href="/data_warehouse/doc/Before You Begin - MHA1.pdf" target="_blank">Before You Begin</a> <br />
            <a href='#' onClick={() => state.startNewAssessementAssessmentSelected(1)}>Begin Assessment</a>
          </td>
        </tr>
        <tr>
          <td >2</td>
          <td >Data Collection</td>
          <td >
            <a href="/data_warehouse/doc/Before You Begin - MHA2.pdf" target="_blank">Before You Begin</a> <br />
            <a href='#' onClick={() => state.startNewAssessementAssessmentSelected(2)}>Begin Assessment</a>
          </td>
        </tr>
        <tr>
          <td >3</td>
          <td >Recording &amp; Processing Data</td>
          <td >
            <a href="/data_warehouse/doc/Before You Begin - MHA3.pdf" target="_blank">Before You Begin</a><br />
            <a href='#' onClick={() => state.startNewAssessementAssessmentSelected(3)}>Begin Assessment</a>

          </td>
        </tr>
        <tr>
          <td >4</td>
          <td >Data Checking Routines</td>
          <td >
            <a href="/data_warehouse/doc/Before You Begin - MHA4.pdf" target="_blank">Before You Begin</a><br />
            <a href='#' onClick={() => state.startNewAssessementAssessmentSelected(4)}>Begin Assessment</a>
          </td>
        </tr>

      </tbody>
    </table>
    <br />
    <button className="dataButton" onClick={() => state.startStartNewAssessementPageBack()}
    >Back</button>

  </div>
);

export default StartNewAssessment;
